const TicketItemSkeleton = ({ noBorder }: { noBorder?: boolean }) => (
    <div
        className={`w-full animate-pulse border-gray-4 px-7 dark:border-dark-1 ${
            noBorder ? '' : 'mb-2 border-b-2 pb-5'
        }`}
    >
        <div className="mb-4 flex">
            <div className="mr-3 h-5 w-[172px] rounded-3xl bg-gray-4 dark:bg-blue-main md:h-[22px]"></div>
            <div className="h-5 w-12 rounded-3xl bg-gray-4 dark:bg-blue-main md:h-[22px]"></div>
        </div>
        <div className="flex">
            <div className="h-12 w-12 rounded-3xl bg-gray-4 dark:bg-blue-main"></div>
            <div className=" mx-3 h-12 w-28 rounded-3xl bg-gray-4 dark:bg-blue-main"></div>
            <div className="h-12 w-12 rounded-3xl bg-gray-4 dark:bg-blue-main"></div>
        </div>
    </div>
);

export const TicketSkeleton = () => {
    return (
        <div
            className="rounded-[15px] bg-ash px-[22px] pb-6 pt-5 dark:bg-blue-1 sm:items-center sm:pb-7 sm:pt-6"
            data-test-id="tickets-skeleton"
        >
            <div className="mb-7 h-[22px] w-full max-w-xs animate-pulse rounded-[30px] bg-gray-4 dark:bg-blue-main md:mx-auto"></div>
            <div className="mx-auto flex w-fit flex-col items-center">
                <TicketItemSkeleton />
                <TicketItemSkeleton />
                <TicketItemSkeleton />
                <TicketItemSkeleton noBorder />
            </div>
        </div>
    );
};
